<template>
  <div class="gropProfile">
    <div class="navtop">
    </div>
    <div class="Tpage">
      <div id="PageLeft">
        <div class="Tit">
          <div class="big">在线举报</div>
        </div>
      </div>
      <div id="PageRight">
        <div class="nav">
          <div class="r">
            <i class="el-icon-house" style="font-size:16px;margin-right:10px"></i>
            <span> 您当前的位置： </span>
            <span>
              <router-link style="font-size:16px" to="/homePage">首页 <span> &nbsp;> </span> </router-link>
            </span>
            <span style="font-size:16px" class="textTitle">{{mathedTitle}} </span>
          </div>
        </div>
        <div class="content">
          <div class="view">
            <div class="reportWrap">
              <el-form ref="ruleForm" :model="form" :rules="rules" label-width="150px">
                <div class="reportInner">
                  <div class="retportHd">举报人信息</div>
                  <div class="reportGrop" style="width: 60%;">
                    <el-form-item label="举报人姓名：" prop="jbUserName">
                      <el-input v-model="form.jbUserName" clearable placeholder="请输入举报人姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话：" prop="jbTel">
                      <el-input v-model="form.jbTel" type="number" clearable placeholder="请输入联系电话"></el-input>
                    </el-form-item>
                    <el-form-item label="您的单位或地址：" prop="jbUserWorkUnit">
                      <el-input v-model="form.jbUserWorkUnit" clearable placeholder="请输入您的单位或地址"></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="reportInner">
                  <div class="retportHd">被举报人信息</div>
                  <div class="reportGrop" style="width: 60%;">
                    <el-form-item label="被举报人姓名：" prop="bjbUserName">
                      <el-input v-model="form.bjbUserName" clearable placeholder="请输入被举报人姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="被举报人单位：" prop="bjbUserWorkUnit">
                      <el-input v-model="form.bjbUserWorkUnit" clearable placeholder="请输入被举报人单位"></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="reportInner">
                  <div class="retportHd">举报信息</div>
                  <div class="reportGrop" style="width: 60%;">
                    <el-form-item label="举报标题：" prop="jbTitle">
                      <el-input v-model="form.jbTitle" clearable placeholder="请输入举报标题"></el-input>
                    </el-form-item>
                    <el-form-item label="举报内容：" prop="jbContent">
                      <el-input v-model="form.jbContent" type="textarea" :rows="4" clearable placeholder="请输入举报内容"></el-input>
                    </el-form-item>
                    <el-form-item label="验证码:" prop="code">
                      <el-input v-model="form.code" type="number" clearable placeholder="请输入验证码" style="width: calc(100% - 150px)"></el-input>
                      <div class="codeImg">
                        <s-identify style="display:inline-block; width: 100%; height:40px;vertical-align:top;cursor:pointer;" :identifyCode="code" :contentHeight="40" :contentWidth="140" @click.native="handleRefreshCode" />
                      </div>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" :loading="loading" @click="submitForm('ruleForm')">立即提交</el-button>
                      <el-button @click="resetForm('ruleForm')">重置</el-button>
                    </el-form-item>
                  </div>
                </div>
              </el-form>
            </div>

          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    addAccuseInform
  } from '@/api/common'
  import SIdentify from '../captcha/index.vue'
  export default {
    components: {
      SIdentify
    },
    data() {
      var checkPhone = (rule, value, callback) => {
        const phoneReg = /^1[3|4|5|7|8][0-9]{9}$/
        if (!value) {
          return callback(new Error('电话号码不能为空'))
        }
        setTimeout(() => {
          // Number.isInteger是es6验证数字是否为整数的方法,实际输入的数字总是识别成字符串
          // 所以在前面加了一个+实现隐式转换

          if (!Number.isInteger(+value)) {
            callback(new Error('请输入数字值'))
          } else {
            if (phoneReg.test(value)) {
              callback()
            } else {
              callback(new Error('电话号码格式不正确'))
            }
          }
        }, 100)
      }
      return {
        rules: {
          jbUserName: [{
            required: true,
            message: '请输入举报人姓名',
            trigger: 'blur'
          }],
          jbTel: [{
              required: true,
              message: '请输入举报人电话',
              trigger: 'blur'
            },
            {
              validator: checkPhone,
              trigger: 'blur'
            }
          ],
          bjbUserName: [{
            required: true,
            message: '请输入被举报人姓名',
            trigger: 'blur'
          }],
          bjbUserWorkUnit: [{
            required: true,
            message: '请输入被举报人单位',
            trigger: 'blur'
          }],
          jbContent: [{
            required: true,
            message: '请输入举报内容',
            trigger: 'blur'
          }],
          code: [{
            required: true,
            message: '请输入验证码',
            trigger: 'blur'
          }]
        },
        loading: false,
        code: '',
        indexPage: {},
        actlistId: '',
        parentId: '',
        isShowv: false,
        listId: '',
        isDeail: false,
        isList: false,
        isArtDel: false,
        fullpath: ' ',
        pathtitle: ' ',
        mathedTitle: '在线举报',
        navSubList: [],
        form: {
          applicationUuid: this.webId,
          
        },
        entTArticleUuid: ''
      }
    },
    computed: {

    },
    mounted() {
      this.handleRefreshCode()
    },
    methods: {
      handleRefreshCode() {
        this.code = (Math.random() * 8999 + 1000).toFixed(0).toString()
      },
      submitForm(formName) {
        var _this = this
        this.loading = true
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (this.form.code != this.code) {
              this.$message({
                type: 'warning',
                message: '验证码错误!'
              })
              this.loading = false
              return
            }
            addAccuseInform(_this.form).then(res => {
              const {
                code
              } = res
              if (code === 1) {
                // this.$message({
                //   showClose: true,
                //   message: '提交成功！'
                // })
                this.loading = false
                this.$confirm('提交成功, 我们会及时联系您！', '提示', {
                    showConfirmButton: false,
                    cancelButtonText: '取消',
                    type: 'success',
                    center: true
                  })
                  .then(() => {
                    // this.$message({
                    //   type: 'success',
                    //   message: '删除成功!'
                    // })
                  })
                  .catch(() => {
                    // this.$message({
                    //   type: 'info',
                    //   message: '已取消删除'
                    // })
                    _this.resetForm('ruleForm')
                  })
              }
              this.loading = false
            })
          } else {
            console.log('error submit!!')
            this.loading = false
            return false
          }
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields()
      },
      // 打开左右箭头
      openShow() {
        this.isShowv = true
      },
      closeShow() {
        this.isShowv = false
      },
    },
  }
</script>

<style lang="scss">
  .navtop {
    background: rgb(242, 242, 242);
    height: 44px;
    position: absolute;
    width: 100%;
  }

  // 轮播背景大图
  .gropProfile .ziHead {
    width: 100%;
    height: auto;
    overflow: hidden;
  }

  .gropProfile .ziHead .swiper-container {
    .swiper-wrapper {
      .swiper-slide {
        width: 100%;
        text-align: center;
        position: relative;
        overflow: hidden;
        height: 540px;
      }
    }
  }

  .gropProfile .ziHead .swiper-button-prev,
  .swiper-container-rtl .swiper-button-next {
    background-image: url("../../assets/image/leftimg.png");
    background-size: cover;
    position: absolute;
    top: 45%;
    margin-top: -15px;
    width: 30px;
    height: 50px;
    z-index: 89;
    opacity: 0.5;
  }

  .gropProfile .ziHead .swiper-button-next,
  .swiper-container-rtl .swiper-button-prev {
    background-image: url("../../assets/image/rightimg.png");
    background-size: cover;
    position: absolute;
    top: 45%;
    margin-top: -15px;
    width: 30px;
    height: 50px;
    z-index: 89;
    opacity: 0.5;
  }

  .gropProfile .ziHead .swiper-button-prev {
    left: -40px;
    transition: all 0.3s linear;
    -moz-transition: 0.3s all linear;
    -webkit-transition: 0.3s all linear;
    -o-transition: 0.3s all linear;
    -ms-transition: 0.3s all linear;
  }

  .gropProfile .ziHead .swiper-button-next {
    right: -40px;
    transition: all 0.3s linear;
    -moz-transition: 0.3s all linear;
    -webkit-transition: 0.3s all linear;
    -o-transition: 0.3s all linear;
    -ms-transition: 0.3s all linear;
  }

  .gropProfile .ziHead .swiper-button-prev.active {
    left: 10px;
  }

  .gropProfile .ziHead .swiper-button-next.active {
    right: 10px;
  }

  .clear {
    width: 100%;
    height: 20px;
    overflow: hidden;
    display: block;
    clear: both;
  }

  .Tpage {
    width: 1200px;
    overflow: hidden;
    margin: 0px auto;
    margin-top: 3px;
    position: relative;
  }

  #PageLeft {
    width: 235px;
    float: left;
    overflow: hidden;
  }

  #PageLeft .Tit {
    width: 235px;
    height: 105px;
    color: #FFFFFF;
    z-index: 9999999;
    background: #0062b3 url(../../assets/image/zi_left_b.png) 35px center no-repeat;
    margin-bottom: 2px;
  }

  #PageLeft .Tit .img {
    width: 64px;
    height: 73px;
    margin: 26px auto 0px auto;
    float: left;
  }

  img {
    display: inline-block;
    border: none;
  }

  .Tit .big {
    width: 140px;
    height: 105px;
    line-height: 105px;
    font-size: 26px;
    float: right;
    margin-left: 95px;
    display: inline-block;
  }

  #PageLeft .Tit .samll {
    width: 100%;
    height: 24px;
    line-height: 24px;
    text-align: center;
    font-size: 14px;
    text-align: center;
    color: #97bde1;
    margin-top: 10px;
  }

  #PageLeft .sort {
    width: 100%;
    overflow: hidden;
  }

  #PageLeft .sort .navMainInner {
    width: 100%;
    height: 50px;
    display: block;
    background-color: #0062b3;
    line-height: 50px;
    text-align: center;
    font-size: 14px;
    color: #ffffff;
    font-weight: bolder;
    margin-bottom: 2px;
  }

  .navMainInner:hover {
    background-color: #d4d4d4 !important;
    color: #0062b3 !important;
  }

  .navMainInner.active {
    background-color: #d4d4d4 !important;
    color: #0062b3 !important;
  }

  #PageRight {
    width: 930px;
    float: right;
    overflow: hidden;
  }

  #PageRight .nav {
    width: 100%;
    height: 42px;
  }

  #PageRight .nav .r {
    height: 44px;
    line-height: 44px;
    font-size: 14px;
    color: #888888;
    cursor: pointer;
  }

  #PageRight .nav .r a {
    font-size: 12px;
    color: #9a9a9a;
  }

  .content {
    font-size: 16px;
    line-height: 30px;
    padding: 0px;
  }

  .content .view {
    padding: 0px 10px;
  }

  .reportWrap {
    padding: 6px;
    margin: 20px 0;
    background-color: #f2f2f2;
  }

  .reportInner {
    background-color: #fff;
    padding-bottom: 2px;
    margin-bottom: 12px;
  }

  .reportInner:last-child {
    margin-bottom: 0;
  }

  .retportHd {
    height: 42px;
    line-height: 42px;
    padding: 0 15px;
    border-bottom: 1px solid #f6f6f6;
    color: #333;
    border-radius: 2px 2px 0 0;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 15px;
  }

  .codeImg {
    display: inline-block;
    width: 140px;
    height: 40px;
    margin-left: 10px;
  }
</style>